export default "__VITE_ASSET__5d5188a0__"